<template>
  <div class="rank">
    <div class="page page2">
      <div class="headline">
        <p>票数排行榜</p>
        <a class="back" href="">返回</a>
      </div>
      <div class="top3 clearfix">
        <div class="box first">
          <i class="icon-rank icon-rank-1"></i>
          <div class="pic-wrap">
            <a class="to-bigpic" href="javascript:void(0)"
              ><img class="pic" src="images/pic-6.png"
            /></a>
          </div>
          <div class="txt-wrap clearfix">
            <img class="face left" src="images/pic-10.png" />
            <div class="left">
              <div class="name">名侦探柯南</div>
              <div class="vote-num">票数 123</div>
            </div>
            <a class="btn-vote right" href="javascript:void(0)">投票</a>
          </div>
        </div>
        <div class="box second">
          <i class="icon-rank icon-rank-2"></i>
          <div class="pic-wrap">
            <a class="to-bigpic" href="javascript:void(0)"
              ><img class="pic" src="images/pic-1.png"
            /></a>
          </div>
          <div class="txt-wrap clearfix">
            <img class="face left" src="images/pic-10.png" />
            <div class="left">
              <div class="name">名侦探柯南</div>
              <div class="vote-num">票数 123</div>
            </div>
            <a class="btn-vote right" href="javascript:void(0)">投票</a>
          </div>
        </div>
        <div class="box third">
          <i class="icon-rank icon-rank-3"></i>
          <div class="pic-wrap">
            <a class="to-bigpic" href="javascript:void(0)"
              ><img class="pic" src="images/pic-8.png"
            /></a>
          </div>
          <div class="txt-wrap clearfix">
            <img class="face left" src="images/pic-10.png" />
            <div class="left">
              <div class="name">名侦探柯南</div>
              <div class="vote-num">票数 123</div>
            </div>
            <a class="btn-vote right" href="javascript:void(0)">投票</a>
          </div>
        </div>
      </div>
      <div class="allphotos rank-allphotos">
        <div class="box">
          <div class="pic-wrap">
            <a class="to-bigpic" href="javascript:void(0)"
              ><img class="pic" src="images/pic-6.png"
            /></a>
          </div>
          <div class="title-wrap clearfix">
            <div class="face left"><img src="images/pic-10.png" /></div>
            <div class="name left"><span>好久的返回加</span></div>
            <div class="rank right">NO.4</div>
          </div>
          <div class="vote-wrap clearfix">
            <div class="vote-num">票数 123</div>
            <a class="btn-vote" href="javascript:void(0)">投票</a>
          </div>
        </div>
        <div class="box">
          <div class="pic-wrap">
            <a class="to-bigpic" href="javascript:void(0)"
              ><img class="pic" src="images/pic-8.png"
            /></a>
          </div>
          <div class="title-wrap clearfix">
            <div class="face left"><img src="images/pic-10.png" /></div>
            <div class="name left"><span>好久的返回加</span></div>
            <div class="rank right">NO.5</div>
          </div>
          <div class="vote-wrap clearfix">
            <div class="vote-num">票数 123</div>
            <a class="btn-vote" href="javascript:void(0)">投票</a>
          </div>
        </div>
        <div class="box">
          <div class="pic-wrap">
            <a class="to-bigpic" href="javascript:void(0)"
              ><img class="pic" src="images/pic-10.png"
            /></a>
          </div>
          <div class="title-wrap clearfix">
            <div class="face left"><img src="images/pic-10.png" /></div>
            <div class="name left"><span>好久的返回加</span></div>
            <div class="rank right">NO.6</div>
          </div>
          <div class="vote-wrap clearfix">
            <div class="vote-num">票数 123</div>
            <a class="btn-vote" href="javascript:void(0)">投票</a>
          </div>
        </div>
        <div class="box">
          <div class="pic-wrap">
            <a class="to-bigpic" href="javascript:void(0)"
              ><img class="pic" src="images/pic-9.png"
            /></a>
          </div>
          <div class="title-wrap clearfix">
            <div class="face left"><img src="images/pic-10.png" /></div>
            <div class="name left"><span>好久的返回加</span></div>
            <div class="rank right">NO.7</div>
          </div>
          <div class="vote-wrap clearfix">
            <div class="vote-num">票数 123</div>
            <a class="btn-vote" href="javascript:void(0)">投票</a>
          </div>
        </div>
      </div>
      <!--<div class="allphotos-non">
		<img src="images/pic-non.png">
		<p>还没有任何投稿作品</p>
	</div>-->
    </div>
    <!--
<div class="loading"><img src="../res/images/loading.gif"></div>
-->
    <!--查看大图-->
    <div class="page3">
      <div class="swiper-container detail">
        <div class="swiper-wrapper"></div>
        <div class="swiper-pagination"></div>
        <a class="del-btn" href="javascript:void(0)"></a>
        <a class="close-btn" href="javascript:void(0)"></a>
      </div>
      <div class="detail-text">
        <div class="title">
          <div class="title-txt">
            时间到了卡时间段飒飒肯时间到了卡时间段德基时间到了卡时间段飒飒肯德基时间到了卡时间段飒飒肯德基德基
          </div>
          <a class="btn-vote" href="javascript:void(0)">123</a>
        </div>
        <div class="desc">
          斯卡迪看见爱上大健康had见斯卡迪看见爱上大健康康had见客户家实打实打所客户家实打实打所
        </div>
      </div>
    </div>
    <!--loading-->
    <div class="loading-bg" style="display: none">
      <div class="loading">
        <span></span><span></span><span></span><span></span><span></span>
      </div>
    </div>
  </div>
</template>

<script>
// import WaterfallRank from "@/components/WaterfallRank";
// import Lightbox from "@/components/Lightbox";
export default {
  components: {
    // Lightbox,
    // WaterfallRank
  },
  data() {
    return {
      works: [],
      rankList: [],
      totalPage: 0,
      // 是否到底部
      end: false,
      curImgList: [],
      isShowLightbox: false
    };
  },
  methods: {
    getData() {
      this.end = true;
      return false;
    },
    lightbox(item) {
      // console.log(item.images);
      this.isShowLightbox = true;
      this.curImgList = item.images;
    },
    changeDisplay() {
      this.isShowLightbox = false;
    }
  },
  created() {
    this.axios
      .post("/match/works?id=112&vote=1")
      .then(res => {
        console.log(res);
        this.works = res.data.data;
        this.rankList = this.works.slice(3);
        // this.rankList = this.works.slice(3, 10);
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>

<style>
.body2 {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
</style>
